module.exports = __webpack_public_path__ + "static/media/NUS_Wheel2.5a482f3f.png";